export enum EFormChatBots {
    telegram = 'telegram',
    instagram = 'instagram',
    viber = 'viber',
    messenger = 'messenger',
    whatsapp = 'whatsapp',
    //tiktok = 'tiktok',
}
